const InitApp = () => {
  const IS_GIFT_SUBSCRIPTION = SETTINGS_WIDGET.settings.template_suffix.indexOf('gift-subscription') !== -1;


  let app = Vue.createApp({
    delimiters: ['${', '}'],

    data() {
      return {
        collection: COLLECTION,
        selected_product: null,
        selected_gift_product: null,
        selected_size: null,
        selected_grind: null,
        selected_frequency: null,
        selected_duration: null,
        quantity: 1,
        subscribe_settings: SETTINGS_WIDGET  
      }
    },

    computed: {
      steps() {
        return [...document.querySelectorAll('[data-step]')].map($item => $item.dataset.step);
      },

      selected_variant() {
        let vm = this;
        let selected_variant = null;
        let product = IS_GIFT_SUBSCRIPTION ? vm.selected_gift_product : vm.selected_product;

        if (!!product && vm.selected_size !== null) {
		
          let size = vm.selected_size;
          let grind = vm.selected_grind;
		  if(product.id == 8334821753007){
			 selected_variant = product.variants.find(v => v.public_title.indexOf(size) !== -1); 
		  }else{
          selected_variant = product.variants.find(v => v.public_title.indexOf(size) !== -1 && v.public_title.indexOf(grind) !== -1);
		  }
		  //	console.log('product',product);
		  //	console.log('size',size);
		  //	console.log('grind',grind);
        }
//console.log('vm.selected_size',vm.selected_size);

        return selected_variant;
      },

      sizes() {
        let vm = this;
        let sizes = [];

        let selected_product = vm[IS_GIFT_SUBSCRIPTION ? 'selected_gift_product' : 'selected_product'];
        if (selected_product !== null) {
          let sizeOption = selected_product.options_with_values.find(option => option.name.toLowerCase() == 'size');
          let available_variants = selected_product.variants.filter(variant => variant.available);
          sizes = available_variants.map(variant => variant[`option${sizeOption.position}`]);

          sizes = _.uniq(sizes);
        }

        // only include sizes configured in settings
        let include_sizes = vm.subscribe_settings.settings.sizes.replaceAll(', ', ',').split(',');
        sizes = sizes.filter(size => include_sizes.indexOf(size) !== -1);

        return sizes;
      },

grinds() {
  let vm = this;
  let grinds = [];

  let selected_product = vm[IS_GIFT_SUBSCRIPTION ? 'selected_gift_product' : 'selected_product'];

  // If no product or no size is selected, return empty
  if (!selected_product || !vm.selected_size) {
    return grinds;
  }

  // Safely check if the product has an options_with_values array
  let grindOption = Array.isArray(selected_product.options_with_values)
    ? selected_product.options_with_values.find(
        option => option.name && option.name.toLowerCase() === 'whole bean or ground'
      )
    : null;

  // ✅ If no grind option exists, return ['Whole Bean'] by default
  if (!grindOption) {
    return ['Whole Bean'];
  }

  // Otherwise, continue with normal logic
  let available_variants = selected_product.variants.filter(
    variant => variant.option1 === vm.selected_size && variant.available
  );

  grinds = available_variants.map(
    variant => variant[`option${grindOption.position}`]
  );

  grinds = _.uniq(grinds);

  // Only include grinds configured in settings
  let include_grinds = vm.subscribe_settings.settings.grinds
    .replaceAll(', ', ',')
    .split(',');

  grinds = grinds.filter(grind => include_grinds.includes(grind));

  return grinds;
},


      mapFrequencySelected() {
        let vm = this;
        let frequency = null, tag;
        if (vm.selected_frequency !== null) {
			
          switch(vm.selected_frequency) {
            case 'weekly': 
              frequency = 1;
              break;
            case 'every other week': 
              frequency = 2;
              tag = 'Bi-Weekly';
              break;
            case 'monthly': 
              frequency = 4;
              tag = 'Monthly'
              break;            
          }
        }

        return {
          tag: tag,
          frequency: frequency
        };
      },

      subscription_price() {
        let vm = this;
        let price = vm.selected_variant ? vm.selected_variant.price : 0;
        let qty = vm.quantity || 1;
 //console.log('selected_variant',vm.selected_variant);
        if (vm.selected_variant_selling_plan) {
          let discount_type = vm.selected_variant_selling_plan.checkout_charge.value_type;
		//  console.log('discount_type',discount_type);
		//  console.log('vm.selected_variant_selling_plan',vm.selected_variant_selling_plan);
          if (discount_type == 'percentage') {
          //  price = price * (vm.selected_variant_selling_plan.checkout_charge.value / 100);
           price = price - (price * (vm.selected_variant_selling_plan.price_adjustments[0].value / 100));
          }  
		
        }
		
		console.log('selected_variant_selling_plan',vm.selected_variant_selling_plan);
		console.log('price new',price);
        return price * qty;
      },
	productactual_price() {
        let vm = this;
        let price = vm.selected_variant ? vm.selected_variant.price : 0;
        let qty = vm.quantity || 1;

        if (vm.selected_variant_selling_plan) {
         let discount_type = vm.selected_variant_selling_plan.checkout_charge.value_type;
		 if (discount_type == 'percentage') {
        
            price = price * (vm.selected_variant_selling_plan.checkout_charge.value / 100);
          }  
		
        }
		
        return price * qty;
      },
	  
	savings_price() {
        let vm = this;
        let price = vm.selected_variant ? vm.selected_variant.price : 0;
        let qty = vm.quantity || 1;

        if (vm.selected_variant_selling_plan) {
         let discount_type = vm.selected_variant_selling_plan.checkout_charge.value_type;
		 if (discount_type == 'percentage') {
        
           price = (price * (vm.selected_variant_selling_plan.price_adjustments[0].value / 100));
          }  
		
        }
		
        return price * qty;
      },
      selected_variant_selling_plan() {
        let vm = this, selling_plan;
        if (!vm.mapFrequencySelected.frequency) return;
        let selected_product = vm[IS_GIFT_SUBSCRIPTION ? 'selected_gift_product' : 'selected_product'];
        if (IS_GIFT_SUBSCRIPTION) {
			//console.log('selected_duration',vm.selected_duration);
			//console.log('selling_plan_groups',selected_product.selling_plan_groups);
          //selling_plan = selected_product.selling_plan_groups[0].selling_plans[0];
		  if(vm.mapFrequencySelected.frequency == 2 && vm.selected_duration =='12 Months'){
		  selling_plan = selected_product.selling_plan_groups[4].selling_plans[0];
		  }
		  else if(vm.mapFrequencySelected.frequency == 4 && vm.selected_duration =='12 Months'){
		  selling_plan = selected_product.selling_plan_groups[4].selling_plans[0];
		  }
		  else if(vm.mapFrequencySelected.frequency == 2 && vm.selected_duration =='6 Months'){
		  selling_plan = selected_product.selling_plan_groups[4].selling_plans[0];
		  }
		  else if(vm.mapFrequencySelected.frequency == 4 && vm.selected_duration =='6 Months'){
		  selling_plan = selected_product.selling_plan_groups[4].selling_plans[0];
		  }
		  else if(vm.mapFrequencySelected.frequency == 2 && vm.selected_duration =='3 Months'){
		  selling_plan = selected_product.selling_plan_groups[4].selling_plans[0];
		  }
		  else if(vm.mapFrequencySelected.frequency == 4 && vm.selected_duration =='3 Months'){
		  selling_plan = selected_product.selling_plan_groups[4].selling_plans[0];
		  }
        }
        else {
          selling_plan = selected_product.selling_plan_groups[vm.mapFrequencySelected.frequency - 1].selling_plans[0];
        }
        return selling_plan;
      },

      selected() {
        let vm = this;
        return {
          product: vm.selected_product,
          gift_product: vm.selected_gift_product,
          variant: vm.selected_variant,
          frequency: vm.mapFrequencySelected,
          selling_plan: vm.selected_variant_selling_plan
        };
      }
    },

    mounted() {
      let vm = this;
    },

    methods: {
      qtyUpdate(e, incr) {
        let $qty_wrap = e.target.closest('.product__quantity');
        let $qty = $qty_wrap.querySelector('[name=quantity]');
        let qty = parseInt($qty.value);

        let new_qty = qty + incr;
        new_qty = (new_qty == 0) ? 1 : new_qty;
        $qty.value = new_qty;
        $qty.dispatchEvent(new CustomEvent('change', { bubbles: true }));
      },

      selectProduct(e, product_id) {
        let vm = this,
          $btn = e.currentTarget,
          $step = $btn.closest('[data-step]'),
          product = vm.collection.products.find(p => p.id === product_id);
		
        if (IS_GIFT_SUBSCRIPTION) {
			product = vm.collection.products.find(p => p.id === product_id);
          //product = vm.collection.products.find(p => p.id !== product_id && p.handle.indexOf(product.handle) !== -1);
        }

        // set product
		
        vm[IS_GIFT_SUBSCRIPTION ? 'selected_gift_product' : 'selected_product'] = product;
	
        let $btn_subscribe = $step.querySelector('.subscribe-btn.selected');
        if ($btn_subscribe) {
          $btn_subscribe.classList.remove('selected');
        }
        
        let $product = $btn.closest('.grid-product__link');
        $product.querySelector('.subscribe-btn').classList.add('selected');

        vm.resetSteps(['size', 'grind', 'frequency']);
        vm.nextStep('size');
      },

      selectSize(e, size) {
        let vm = this;
        let $btn = e.currentTarget;

        vm.selected_size = size;

        // set quantity
        let qty = parseInt($btn.closest('.grid-product').querySelector('.js-qty__num').value);
        vm.quantity = qty;

        vm.resetSteps(['grind', 'frequency']);
        vm.nextStep('grind');   
      },

      selectGrind(e, grind) {
        let vm = this;

        // set grind
        vm.selected_grind = grind;

        vm.resetSteps(['frequency']);
        vm.nextStep('frequency');
      },        

      selectFrequency(e, frequency) {
        let vm = this;

        // set frequency
        vm.selected_frequency = frequency;

        // Update Correct product based on selections.
        vm.updateSelectedProduct();

        vm.nextStep(IS_GIFT_SUBSCRIPTION ? 'duration' : 'order-summary');
      },

      selectDuration(e, duration) {
        var vm = this;
        vm.selected_duration = duration;
        
        // Update Correct product based on selections.
        vm.updateSelectedProduct();

        vm.nextStep('order-summary');
      },

      updateSelectedProduct() {
        let vm = this;
        if (!vm.selected_frequency || !vm.selected_duration) return;

        let selected_product = vm[IS_GIFT_SUBSCRIPTION ? 'selected_gift_product' : 'selected_product'];
	
        let selected_group = vm.collection.groups.find(group => group.products.map(p => p.id).indexOf(selected_product.id) !== -1);
        let selected_gift_product = selected_group.products.find(p => p.tags.indexOf(vm.mapFrequencySelected.tag) !== -1 &&
                                                                p.tags.indexOf(vm.selected_duration) !== -1);
        vm.selected_product = vm.selected_gift_product = selected_product;
      },

      resize_image(src, size) {
        var resized = src || '';
        resized = resized.replace('.png', `_${size}.png`);
        resized = resized.replace('.jpg', `_${size}.jpg`);
  
        return resized;    
      },  

      format_money(value) {
        return theme.Currency.formatMoney(value);
      },

      nextStep(step_identifier) {
        let vm = this;
        let nextStepSelector = `[data-step=${step_identifier}]`;
        let $nextStepContainer = document.querySelector(nextStepSelector);
        $nextStepContainer.classList.remove('hide');

        vm.scrollTo(nextStepSelector);
      },

      resetSteps(steps) {
        let vm = this;
        steps.forEach((step) => {
          vm[`selected_${step}`] = null;

          switch(step) {
            case 'size':
              document.querySelector('#step--size').classList.add('hide');
              let $qty = document.querySelector('.js-qty__num');
              if ($qty) {
                $qty.value = 1;
              }
              break;
            case 'grind':
              document.querySelector('#step--grind').classList.add('hide');
              break;
            case 'frequency':
              document.querySelector('#step--frequency').classList.add('hide');
              break;
          }
        });

        document.querySelector('#step--order-summary').classList.add('hide');
      },

      scrollTo(selector) {
        let $step = document.querySelector(selector);
        let scrollPosition = $step.offsetTop;
        let $sticky_header = document.querySelector('.site-header--stuck');
        let offset = $sticky_header ? $sticky_header.offsetHeight : 0;

        window.scrollTo({
          top: scrollPosition - offset,
          behavior: 'smooth'
        });
      },

      addSubscriptionToCart(e) {
        let vm = this;

        let variantToAdd = {
          variant_id: vm.selected_variant.id,
          quantity: vm.quantity,
          selling_plan: vm.selected_variant_selling_plan.id
        };

        if (IS_GIFT_SUBSCRIPTION) {
          variantToAdd.properties = {
            'Subscription Type': "Gift"
          };
        }

        (async () => {
          let res = await UTILS.addItemToCart(variantToAdd);
          if (res.ok) {
            UTILS.refreshCart();
          }
        })();
      },
      
      labelIconImgUrl(value) {
        let vm = this;
        let icon_img_url = '';
        let icon_img = vm.subscribe_settings.blocks.find(block => block.label == value);
        
        if (icon_img !== undefined) {
          icon_img_url = icon_img.img_url;
        }
        
        return icon_img_url;
      }
    }
  });

  app.mount('#subscription');
}

InitApp();
document.addEventListener('shopify:section:load', InitApp);
